import { Injectable } from '@angular/core';
import { StorageType } from '@common/models';

@Injectable()
export class UiDataService {
  private readonly regionTypes = new Set<StorageType>([StorageType.AmazonS3UnifiedBilling, StorageType.WasabiUnifiedBilling]);
  private readonly endpointSuffixTypes = new Set<StorageType>([StorageType.AzureStack]);
  private readonly endpointTypes = new Set<StorageType>([
    StorageType.S3Compatible,
    StorageType.Minio,
    StorageType.Swift,
    StorageType.Wasabi
  ]);

  isAvailableEndpoint(type: StorageType): boolean {
    return this.endpointTypes.has(type);
  }

  isAvailableEndpointSuffix(type: StorageType): boolean {
    return this.endpointSuffixTypes.has(type);
  }

  isAvailableRegion(type: StorageType): boolean {
    return this.regionTypes.has(type);
  }
}
